import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { AuthService } from '../_services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class IsAuthenticatedGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.isLoggedIn$.pipe(
      tap(isLoggedIn => {
        if (!isLoggedIn) {
          this.router.navigate(['login']);
        } else {
          this.authService._isAdvertiser$.subscribe(isAdvertiser => {
            if (isAdvertiser) {
              if (route.routeConfig?.path?.includes('admin')) {
                this.router.navigate(['page-not-found'])
              }
            } else {
              if (route.routeConfig?.path?.includes('promoter')) {
                this.router.navigate(['page-not-found'])
              }
              if(route.routeConfig?.path?.includes('promoter/personal-profile')){
                this.router.navigate(['admin/my-profile']);
              }
            }
          })
        }
      })
    );
  }
}
